import {
  INICIA_ENQUETES,
  NOVO_ENQUETE,
  INICIO_ENQUETES_SUCESSO,
  SALVA_ENQUETE_LOCAL,
  SALVA_ENQUETE_SUCESSO,
  REMOVE_ENQUETE_LOCAL,
  REMOVE_ENQUETE_SUCESSO,
  LISTA_ENQUETES,
  LISTA_ENQUETES_SUCESSO,
  BUSCA_ENQUETE_EDICAO,
  BUSCA_ENQUETE_EDICAO_SUCESSO,
  ABRE_DASHBOARD_ENQUETE,
  ABRE_DASHBOARD_ENQUETE_SUCESSO,
  FECHA_DASHBOARD_ENQUETE,
  REGISTRA_VOTO_ENQUETE,
  REGISTRA_VOTO_ENQUETE_SUCESSO,
  CANCELA_EDICAO_ENQUETE,
  LIMPAR_ENQUETE,
  ENQUETES_SHOW_MESSAGE,
  ENQUETES_HIDE_MESSAGE,
  ALTERACAO_DATEPICKER,
  ATUALIZA_HORARIO,
  ALTERACAO_CAMPO,
  APLICA_FILTRO,
  ON_SHOW_LOADER,
  ALTERACAO_COMBO,
  ON_HIDE_LOADER,
  SETAR_IMAGEM_ENQUETE,
} from 'constants/ActionTypes';
import moment from 'moment';

const normalizaOpcao = (opcao) => ({
  id: opcao?.id ?? opcao?.Id ?? 0,
  idEnquete: opcao?.idEnquete ?? opcao?.IdEnquete ?? 0,
  opcaoLetra: opcao?.opcaoLetra ?? opcao?.OpcaoLetra ?? '',
  textoCorpo: opcao?.textoCorpo ?? opcao?.TextoCorpo ?? '',
  urlImagem: opcao?.urlImagem ?? opcao?.UrlImagem ?? '',
  votosContagem: opcao?.votosContagem ?? opcao?.VotosContagem ?? 0,
});

const normalizaTexto = (valor) => String(valor || '').trim();

const extraiNomeEscola = (enquete) => {
  const nomeDireto = enquete?.nomeEscola ?? enquete?.NomeEscola ?? enquete?.escolaNome ?? enquete?.EscolaNome;

  if (normalizaTexto(nomeDireto) !== '') {
    return normalizaTexto(nomeDireto);
  }

  const escolaObj = enquete?.escola ?? enquete?.Escola;

  if (typeof escolaObj === 'string' && normalizaTexto(escolaObj) !== '') {
    return normalizaTexto(escolaObj);
  }

  if (escolaObj && typeof escolaObj === 'object') {
    const nomeObj = escolaObj?.nome ?? escolaObj?.Nome ?? escolaObj?.title ?? escolaObj?.Title;
    if (normalizaTexto(nomeObj) !== '') {
      return normalizaTexto(nomeObj);
    }
  }

  const escolas = enquete?.escolas ?? enquete?.Escolas;

  if (Array.isArray(escolas) && escolas.length > 0) {
    const primeira = escolas[0];

    if (typeof primeira === 'string' && normalizaTexto(primeira) !== '') {
      return normalizaTexto(primeira);
    }

    if (primeira && typeof primeira === 'object') {
      const nomeLista = primeira?.nome ?? primeira?.Nome ?? primeira?.title ?? primeira?.Title;
      if (normalizaTexto(nomeLista) !== '') {
        return normalizaTexto(nomeLista);
      }
    }
  }

  const idEscola = enquete?.idEscola ?? enquete?.IdEscola ?? 0;
  return idEscola > 0 ? `Escola ${idEscola}` : '';
};

const formataDataEncerramento = (enquete) => {
  const dataBruta = normalizaTexto(
    enquete?.dataEncerramento
    ?? enquete?.DataEncerramento
    ?? enquete?.dataFim
    ?? enquete?.DataFim,
  );

  const horaBruta = normalizaTexto(enquete?.horaEncerramento ?? enquete?.HoraEncerramento);

  if (!dataBruta && !horaBruta) {
    return '';
  }

  if (!dataBruta) {
    return horaBruta;
  }

  const baseData = dataBruta.includes('T') ? dataBruta.split('T')[0] : dataBruta;
  const partesData = baseData.split('-');
  const dataFormatada = partesData.length === 3
    ? `${partesData[2]}/${partesData[1]}/${partesData[0]}`
    : dataBruta;

  if (!horaBruta) {
    return dataFormatada;
  }

  return `${dataFormatada} | ${horaBruta}`;
};

const formataStatus = (enquete) => {
  const status = normalizaTexto(enquete?.status ?? enquete?.Status);

  if (status !== '') {
    return status;
  }

  if (typeof enquete?.ativa === 'boolean') {
    return enquete.ativa ? 'Ativo' : 'Inativo';
  }

  if (typeof enquete?.Ativa === 'boolean') {
    return enquete.Ativa ? 'Ativo' : 'Inativo';
  }

  return '';
};

const criaEnqueteNova = () => ({
  id: '',
  idEscola: 0,
  titulo: '',
  questao: '',
  subtitulo: '',
  descricao: '',
  status: 'Rascunho',
  totalVotos: 0,
  idResponsavel: Number(localStorage.getItem('user_id')) || 0,
  escolas: [],
  idsEscolas: [],
  idsTurmas: [],
  dataInicio: '',
  dataFim: '',
  dataEncerramento: '',
  horaEncerramento: '',
  ativa: true,
  permiteAlterarVoto: false,
  mostrarResultadosAntesVotar: false,
  usuarioJaVotou: false,
  opcoes: [
    { id: 0, idEnquete: 0, opcaoLetra: 'A', textoCorpo: '', urlImagem: '', votosContagem: 0 },
    { id: 0, idEnquete: 0, opcaoLetra: 'B', textoCorpo: '', urlImagem: '', votosContagem: 0 },
  ],
});

const normalizaEnquete = (enquete) => ({
  id: enquete?.id ?? enquete?.Id ?? 0,
  idEscola: enquete?.idEscola ?? enquete?.IdEscola ?? 0,
  titulo: enquete?.titulo ?? enquete?.Titulo ?? enquete?.nomeEnquete ?? '',
  questao: enquete?.questao ?? enquete?.Questao ?? '',
  subtitulo: enquete?.subtitulo ?? enquete?.Subtitulo ?? '',
  descricao: enquete?.descricao ?? enquete?.Descricao ?? '',
  status: enquete?.status ?? enquete?.Status ?? '',
  totalVotos: enquete?.totalVotos ?? enquete?.TotalVotos ?? 0,
  idResponsavel: enquete?.idResponsavel ?? enquete?.IdResponsavel ?? 0,
  escolas: enquete?.escolas ?? enquete?.Escolas ?? null,
  idsEscolas: enquete?.idsEscolas ?? enquete?.IdsEscolas ?? [],
  idsTurmas: enquete?.idsTurmas ?? enquete?.IdsTurmas ?? [],
  dataInicio: enquete?.dataInicio ?? enquete?.DataInicio ?? '',
  dataFim: enquete?.dataFim ?? enquete?.DataFim ?? '',
  dataEncerramento: enquete?.dataEncerramento ?? enquete?.DataEncerramento ?? enquete?.dataHoraEncerramento ?? '',
  horaEncerramento: enquete?.horaEncerramento ?? enquete?.HoraEncerramento ?? '',
  ativa: enquete?.ativa ?? enquete?.Ativa ?? true,
  permiteAlterarVoto: enquete?.permiteAlterarVoto ?? enquete?.PermiteAlterarVoto ?? false,
  mostrarResultadosAntesVotar: enquete?.mostrarResultadosAntesVotar ?? enquete?.MostrarResultadosAntesVotar ?? false,
  opcaoVotadaPeloUsuario: enquete?.opcaoVotadaPeloUsuario ?? enquete?.OpcaoVotadaPeloUsuario ?? '',
  usuarioJaVotou: enquete?.usuarioJaVotou ?? enquete?.UsuarioJaVotou ?? false,
  nomeEscolaExibicao: extraiNomeEscola(enquete),
  nomeEnqueteExibicao: normalizaTexto(enquete?.titulo ?? enquete?.Titulo),
  dataEncerramentoExibicao: formataDataEncerramento(enquete),
  statusExibicao: formataStatus(enquete),
  opcoes: Array.isArray(enquete?.opcoes || enquete?.Opcoes)
    ? (enquete.opcoes || enquete.Opcoes).map(normalizaOpcao)
    : [],
});

const normalizaEnqueteUnica = (enquete) => ({
  id: enquete?.id ?? enquete?.Id ?? '',
  nome: enquete.nome,
  observacao: enquete.observacao,
  pergunta: enquete.pergunta,
  encerramentoData: enquete.encerramentoEm !== null ? moment(enquete.encerramentoEm) : null,
  encerramentoHora: enquete.encerramentoEm !== null ? moment(enquete.encerramentoEm).format('HH:mm') : null,
  permiteMultiplasRespostas: enquete.permiteMultiplasRespostas,
  permiteAlterarResposta: enquete.permiteAlterarResposta,
  permiteComentario: enquete.permiteComentario,
  votoUnicoPorResponsavel: enquete.votoUnicoPorResponsavel,
  visualizacaoResultado: enquete.visualizacaoResultado,
  escolasIds: enquete.escolasIds,
  alternativas: enquete.alternativas,
  urlImagem: enquete.urlImagem,
  status: enquete.status
});

const normalizaLista = (payload) => {
  if (Array.isArray(payload)) {
    return payload.map(normalizaEnquete);
  }

  if (payload && Array.isArray(payload.data)) {
    return payload.data.map(normalizaEnquete);
  }

  if (payload && Array.isArray(payload.items)) {
    return payload.items.map(normalizaEnquete);
  }

  if (payload && typeof payload === 'object') {
    return Object.values(payload).filter(item => item && typeof item === 'object').map(normalizaEnquete);
  }

  return [];
};

const filtraLista = (lista, textoFiltro) => {
  const termo = String(textoFiltro || '').trim().toLowerCase();

  if (!termo) {
    return lista;
  }

  return lista.filter((item) => {
    const nomeEscola = String(item.nomeEscolaExibicao || '').toLowerCase();
    const nomeEnquete = String(item.nomeEnqueteExibicao || item.titulo || '').toLowerCase();
    const dataEncerramento = String(item.dataEncerramentoExibicao || '').toLowerCase();
    const status = String(item.statusExibicao || item.status || '').toLowerCase();

    return nomeEscola.includes(termo)
      || nomeEnquete.includes(termo)
      || dataEncerramento.includes(termo)
      || status.includes(termo);
  });
};

const INIT_STATE = {
  colunasGrid: [
    { titulo: 'Nome da Escola', propriedadeApi: 'nomeEscolaExibicao', alinhamento: 'left' },
    { titulo: 'Nome da Enquete', propriedadeApi: 'nomeEnqueteExibicao', alinhamento: 'left' },
    { titulo: 'Data de Encerramento', propriedadeApi: 'dataEncerramentoExibicao', alinhamento: 'left' },
    { titulo: 'Status', propriedadeApi: 'statusExibicao', alinhamento: 'left' },
  ],
  loader: false,
  alertMessage: '',
  showMessageSuccess: false,
  showMessageError: false,
  edicao: false,
  dashboard: false,
  carregandoLista: true,
  listGrid: [],
  listGridComFiltro: [],
  idsEscola: [],
  id: null,
  nome: "",
  observacao: "",
  pergunta: "",
  status: 2,
  urlImagem: null,
  alteraFoto: false,
  encerramentoData: null,
  encerramentoHora: null,
  permiteMultiplasRespostas: false,
  permiteAlterarResposta: true,
  permiteComentario: true,
  tipoSelecao: 1,
  votoUnicoPorResponsavel: true,
  visualizacaoResultado: 2,
  escolasIds: [],
  alternativas: [
    {
      texto: "",
      ordem: "A",
      imagemUrl: ""
    },
    {
      texto: "",
      ordem: "B",
      imagemUrl: ""
    },
  ],  
  textoFiltro: '',
  enqueteSelecionada: null,
  idSelecionado: 0,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case INICIA_ENQUETES: {
      return {
        ...state,
        edicao: false,
        loader: true,
        carregandoLista: true,
        textoFiltro: '',
        enqueteSelecionada: null,
        idSelecionado: 0,
        dashboard: false,
      };
    }
    case ALTERACAO_COMBO: {
      return {
        ...state,
        [action.payload.nomeCombo]: action.payload.valor,
      }
    }
    case NOVO_ENQUETE: {
      return {
        ...state,
        edicao: true,
        dashboard: false,
        loader: false,
        enqueteSelecionada: criaEnqueteNova(),
        idsEscola: [
        ],
        idSelecionado: 0,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
      };
    }
    case LISTA_ENQUETES: {
      return {
        ...state,
        loader: true,
        carregandoLista: true,
      };
    }
    case INICIO_ENQUETES_SUCESSO:
    case LISTA_ENQUETES_SUCESSO: {
      const lista = normalizaLista(action.payload);
      return {
        ...state,
        id: null,
        nome: "",
        observacao: "",
        pergunta: "",
        urlImagem: null,
        encerramentoData: null,
        encerramentoHora: null,
        permiteMultiplasRespostas: false,
        permiteAlterarResposta: true,
        permiteComentario: true,
        tipoSelecao: 1,
        votoUnicoPorResponsavel: true,
        visualizacaoResultado: 2,
        escolasIds: [],
        status: 2,
        alternativas: [
          {
            texto: "",
            ordem: "A",
            imagemUrl: ""
          },
          {
            texto: "",
            ordem: "B",
            imagemUrl: ""
          },
        ],  
        loader: false,
        carregandoLista: false,
        listGrid: lista,
        listGridComFiltro: filtraLista(lista, state.textoFiltro),
      };
    }
    case ALTERACAO_CAMPO: {
      return {
        ...state,
        [action.payload.target.name]: action?.payload?.target?.value,
      }
    }
    case BUSCA_ENQUETE_EDICAO: {
      return {
        ...state,
        loader: true,
        idSelecionado: action.payload || 0,
      };
    }
    case BUSCA_ENQUETE_EDICAO_SUCESSO: {
      const enquete = normalizaEnqueteUnica(action.payload);
      return {
        ...state,
        loader: false,
        edicao: true,
        dashboard: false,
        ...enquete,
        idSelecionado: enquete.id || state.idSelecionado,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
      };
    }
    case SALVA_ENQUETE_LOCAL: {
      return {
        ...state,
        loader: true,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
      };
    }
    case SALVA_ENQUETE_SUCESSO: {
      const resultado = action.payload || {};
      const enquete = normalizaEnquete(resultado.enquete || resultado);
      const continuarNovo = !!resultado.continuarNovo;
      return {
        ...state,
        loader: false,
        listGrid: Array.isArray(resultado.lista) ? resultado.lista.map(normalizaEnquete) : state.listGrid,
        listGridComFiltro: Array.isArray(resultado.lista) ? filtraLista(resultado.lista.map(normalizaEnquete), state.textoFiltro) : state.listGridComFiltro,
        enqueteSelecionada: continuarNovo ? criaEnqueteNova() : enquete,
        idSelecionado: continuarNovo ? 0 : enquete.id,
        edicao: continuarNovo,
        dashboard: false,
        alertMessage: resultado.mensagem || 'Enquete salva com sucesso.',
        showMessageSuccess: true,
        showMessageError: false,
      };
    }
    case REMOVE_ENQUETE_LOCAL: {
      return {
        ...state,
        loader: true,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
      };
    }
    case REMOVE_ENQUETE_SUCESSO: {
      const resultado = action.payload || {};
      return {
        ...state,
        loader: false,
        listGrid: Array.isArray(resultado.lista) ? resultado.lista.map(normalizaEnquete) : state.listGrid,
        listGridComFiltro: Array.isArray(resultado.lista) ? filtraLista(resultado.lista.map(normalizaEnquete), state.textoFiltro) : state.listGridComFiltro,
        enqueteSelecionada: null,
        idSelecionado: 0,
        edicao: false,
        dashboard: false,
        alertMessage: resultado.mensagem || 'Enquete removida com sucesso.',
        showMessageSuccess: true,
        showMessageError: false,
      };
    }
    case ABRE_DASHBOARD_ENQUETE: {
      return {
        ...state,
        loader: true,
        idSelecionado: action.payload || state.idSelecionado,
      };
    }
    case FECHA_DASHBOARD_ENQUETE: {
      return {
        ...state,
        dashboard: false,
        loader: false,
      };
    }
    case ABRE_DASHBOARD_ENQUETE_SUCESSO: {
      const enquete = normalizaEnquete(action.payload);
      return {
        ...state,
        loader: false,
        dashboard: true,
        edicao: false,
        enqueteSelecionada: enquete,
        idSelecionado: enquete.id || state.idSelecionado,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
      };
    }
    case REGISTRA_VOTO_ENQUETE: {
      return {
        ...state,
        loader: true,
      };
    }
    case REGISTRA_VOTO_ENQUETE_SUCESSO: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload,
        showMessageSuccess: true,
        dashboard: false,
      };
    }
    case CANCELA_EDICAO_ENQUETE: {
      return {
        ...state,
         id: null,
        nome: "",
        observacao: "",
        pergunta: "",
        urlImagem: null,
        encerramentoData: null,
        encerramentoHora: null,
        permiteMultiplasRespostas: false,
        permiteAlterarResposta: true,
        permiteComentario: true,
        tipoSelecao: 1,
        votoUnicoPorResponsavel: true,
        visualizacaoResultado: 2,
        escolasIds: [],
        status: 2,
        alternativas: [
          {
            texto: "",
            ordem: "A",
            imagemUrl: ""
          },
          {
            texto: "",
            ordem: "B",
            imagemUrl: ""
          },
        ],  
        edicao: false,
        dashboard: false,
        enqueteSelecionada: null,
        idSelecionado: 0,
        loader: false,
      };
    }
    case LIMPAR_ENQUETE: {
      return {
        ...state,
        textoFiltro: '',
        listGridComFiltro: state.listGrid,
      };
    }
    case SETAR_IMAGEM_ENQUETE: {
        
      var retorno = action.payload;
      return {
      ...state,
      alteraFoto: true,
      urlImagem: retorno.imagem,
      }
    }
    case ALTERACAO_DATEPICKER: {
      return {
        ...state,
        [action.payload.name]: moment(action.payload.date)
      }
    }
    case ATUALIZA_HORARIO: {
      return {
        ...state,
        [action.payload.name]: moment(action.payload.date).format('YYYY-MM-DD'),
      }
    }
    case APLICA_FILTRO: {
      const texto = action.payload || '';
      return {
        ...state,
        textoFiltro: texto,
        listGridComFiltro: filtraLista(state.listGrid, texto),
      };
    }
    case ENQUETES_SHOW_MESSAGE:
      return {
        ...state,
        loader: false,
        alertMessage: action.payload,
        showMessageError: true,
      };
    case ENQUETES_HIDE_MESSAGE:
      return {
        ...state,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
        loader: false,
      };
    case ON_SHOW_LOADER:
      return {
        ...state,
        loader: true,
      };
    case ON_HIDE_LOADER:
      return {
        ...state,
        loader: false,
      };
    default:
      return state;
  }
};
